<template>
  <div class="editPage" v-loading="subLoading">
    <qx-card :title="pageTitle">
      <BaseForm ref="baseForm" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import SubBtnBox from 'components/subBtnBox';
import {otherIncomeEdit} from 'api/getPay';
import pageDataMixin from '@qx/mixin/pageData';
import {saveSearch} from '@qx/utils/cache';
import {mapState} from 'vuex';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/getPay/customer/income/edit',
      formComponents: ['baseForm'],
      subLoading: false,
      editParams: {
        type: 1,
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {
    editApi: otherIncomeEdit,
    handleParams (params) {
      this.params = params;
    },
    handleSubSucc (res) {
      const data = this.params;
      const userId = this.userInfo.staffTFInfo.userId;
      if (res && res.code && res.code === 200) {
        if (data.oppositeAccountNumber !== '') {
          console.log('对方账号', data.oppositeAccountNumber);
          saveSearch(`${userId}_opAcctNum`, data.oppositeAccountNumber); // 本地存储搜索的内容
        }
        if (data.oppositeAccountName !== '') {
          console.log('对方户名', data.oppositeAccountName);
          saveSearch(`${userId}_opAcctName`, data.oppositeAccountName); // 本地存储搜索的内容
        }
        this.close();
      }
    },
  },
  async mounted () {
    await this.$refs.baseForm.getList();
    this.getData();
    const userId = this.userInfo.staffTFInfo.userId;
    saveSearch(`${userId}_opAcctNum`, ''); // 进入页面默认存一条对方账户搜索记录为空，解决第一次搜索对方账户时转圈问题
    saveSearch(`${userId}_opAcctName`, ''); // 进入页面默认存一条对方户名搜索记录为空，解决第一次搜索对方账户时转圈问题
  },
};
</script>

<style scoped lang="scss">
</style>
